import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { ReportResources } from 'services/resources/company-report';

import { Page } from './components/Page';

export const ReportsPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('company-report');

  return (
    <CRUDProvider
      allowPost
      quote={t('page.quote')}
      resource={ReportResources}
      searchBy="company__name"
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
